import { Card, Col, Form, Input, Layout, Row, Select, Switch } from "antd";
import { get, toNumber } from "lodash";
import includes from "lodash/includes";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import FormActionButton from "src/components/common/FormActionButton";
import { messages } from "src/constants/messages";
import { apiCaller, cancelListToken } from "src/util/apiCaller";
import { MessageStatusError } from "src/util/MessageStatus";

const FormItem = Form.Item;
const initialState = {
  tenLoaiTuLieu: "",
  idNhomTuLieu: undefined
};

const LoaiTaiLieuForm = ({ status }: any) => {
  const { isActive } = status;
  const navigate = useNavigate();
  const location = useLocation();
  const [type, setType] = useState("new");
  const [fieldTouch, setFieldTouch] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [loadingButtonClose, setLoadingButtonClose] = useState(false);
  const [form] = Form.useForm();
  const { tenLoaiTuLieu, idNhomTuLieu } = initialState;
  const [isLoadingNhomTaiLieu, setIsLoadingNhomTaiLieu] = useState(false);
  const [listNhomTaiLieu, setListNhomTaiLieu] = useState([]);
  const { validateFields, resetFields, setFieldsValue } = form;
  const { id } = useParams();

  useEffect(() => {
    if (isActive) {
      const load = () => {
        if (includes(location.pathname, "them-moi")) {
          setType("new");
        } else {
          setType("edit");
          getInfo();
        }
      };
      getNhomTaiLieu();
      load();
    } else {
      navigate("/error/401");
    }
  }, []);

  useEffect(() => {
    return () => {
      cancelListToken(["infoLoaiTaiLieu"]);
    };
  }, []);

  const getNhomTaiLieu = async () => {
    setIsLoadingNhomTaiLieu(true);
    const configAPI = {
      url: `api/nhomtulieus?keyword`,
      method: "GET",
      value: null,
      apiType: "LIST",
      getName: "listNhomTaiLieu"
    } as any;
    const response = await apiCaller(configAPI);
    try {
      if (
        response?.data &&
        (response.status === 200 || response.status === 201)
      ) {
        setListNhomTaiLieu(get(response.data, "content", []));
        setIsLoadingNhomTaiLieu(false);
      } else {
        MessageStatusError(toNumber(response?.status));
      }
    } finally {
      setIsLoadingNhomTaiLieu(false);
    }
  };

  /**
   * getInfo : Lấy thông tin
   * @memberof  LoaiTaiLieuForm
   */
  const getInfo = async () => {
    if (location.state && location.state.itemData) {
      // Nếu có dữ liệu truyền sang
      const res = location.state.itemData;
      setFieldsValue({
        loaitailieu: res
      });
    } else {
      const configAPI = {
        url: `api/loaitulieu/${id}`,
        method: "GET",
        value: "",
        apiType: "DETAIL",
        getName: "infoLoaiTaiLieu"
      };
      const response = await apiCaller(configAPI);
      try {
        if (
          response?.data &&
          (response.status === 200 || response.status === 201)
        ) {
          setFieldsValue({
            loaitailieu: response.data
          });
        } else {
          MessageStatusError(toNumber(response?.status));
        }
      } catch (error) {
        // Xử lý lỗi khi lưu dữ liệu không thành công
      }
    }
  };

  /**
   * goBack : quay lại trang danh sách
   * @memberof  LoaiTaiLieuForm
   */
  const goBack = () => {
    navigate("/quan-tri/loai-tu-lieu");
  };

  /**
   * save: Lưu
   * @memberof LoaiTaiLieuForm
   */
  const save = () => {
    validateFields()
      .then((values) => {
        setLoadingButton(true);
        saveData(values, false);
      })
      .catch(() => {
        setLoadingButton(false);
      });
  };

  /**
   * saveAndClose: Lưu và đóng
   * @memberof LoaiTaiLieuForm
   */
  const saveAndClose = () => {
    validateFields()
      .then((values) => {
        setLoadingButton(true);
        saveData(values, true);
      })
      .catch(() => {
        setLoadingButton(false);
      });
  };

  /**
   * saveData: Lưu dữ liệu
   * @param {object} values
   * @param {boolean} saveQuit
   * @memberof LoaiTaiLieuForm
   */
  const saveData = async (values: any, saveQuit = false) => {
    try {
      const data = values.loaitailieu;
      data.isSuDung = true;
      let configAPI;
      if (type === "new") {
        configAPI = {
          url: `api/loaitulieu/create`,
          method: "POST",
          data: data,
          apiType: "ADD",
          isShowMessage: true
        };
      } else {
        configAPI = {
          url: `api/loaitulieu/${id}`,
          method: "PUT",
          data: data,
          apiType: "EDIT",
          isShowMessage: true
        };
      }

      const response = await apiCaller(configAPI);
      if (response?.status === 200 || response?.status === 201) {
        if (saveQuit) {
          goBack();
          setLoadingButtonClose(false);
        } else {
          if (type === "new") {
            resetFields();
          }
          setFieldTouch(false);
          setLoadingButton(false);
        }
      } else {
        MessageStatusError(toNumber(response?.status));
        setLoadingButton(false);
      }
    } catch (error) {
      setLoadingButton(false);
    }
  };

  const formTitle =
    type === "new" ? "Thêm mới loại tài liệu" : "Chỉnh sửa loại tài liệu";
  return (
    <Layout>
      <div style={{ display: "flex" }}>
        <Col md={12}>
          <h2 style={{ color: "black", fontSize: 20, marginTop: 10 }}>
            {formTitle}
          </h2>
        </Col>
      </div>
      <Card>
        <Form
          className="form-container wrapper-content-inner"
          layout="vertical"
          form={form}
          name="loaitailieu-control"
          onFieldsChange={() => setFieldTouch(true)}
        >
          <Row gutter={24}>
            <Col md={12} xs={24}>
              <FormItem
                className="QTI-FormItemSelect"
                label="Nhóm tài liệu"
                name={["loaitailieu", "idNhomTuLieu"]}
                initialValue={idNhomTuLieu || undefined}
                rules={[
                  {
                    required: true,
                    message: messages.ERROR_REQUIRED
                  }
                ]}
              >
                <Select
                  allowClear
                  // onChange={onChangeNhomTuLieu}
                  loading={isLoadingNhomTaiLieu}
                  placeholder="Chọn nhóm tài liệu"
                  style={{ width: "100%" }}
                  options={listNhomTaiLieu}
                  fieldNames={{ label: "tenNhomTuLieu", value: "id" }}
                />
              </FormItem>
            </Col>
            <Col md={12} xs={24}>
              <FormItem
                className="ant-input-group"
                label="Tên loại tài liệu"
                name={["loaitailieu", "tenLoaiTuLieu"]}
                rules={[
                  {
                    type: "string",
                    required: true,
                    message: messages.ERROR_REQUIRED
                  }
                ]}
                initialValue={tenLoaiTuLieu}
              >
                <Input
                  className="input-item"
                  placeholder="Nhập tên loại tài liệu"
                />
              </FormItem>
            </Col>
          </Row>
          <hr />
          <FormActionButton
            goBack={goBack}
            saveAndClose={saveAndClose}
            disabled={fieldTouch}
            save={save}
            type={type}
            loadingButton={loadingButton}
            loadingButtonClose={loadingButtonClose}
          />
        </Form>
      </Card>
    </Layout>
  );
};

export default LoaiTaiLieuForm;
